import { ACCESS_TOKEN_DATA_KEY } from "./constants";

export const getAccessToken = (): string | null => {
  const storedData = localStorage.getItem(ACCESS_TOKEN_DATA_KEY);

  if (!storedData) {
    return null;
  }

  const accessTokenData = JSON.parse(storedData);

  return accessTokenData?.accessToken;
};
